/* eslint-disable react/prop-types */
import React from 'react';
import {
  Text,
  Page,
  Document,
  StyleSheet,
  Image,
  View,
} from '@react-pdf/renderer';
import logo from '../../assets/img/aplicontroll.png';
import InvoiceTitle from './InvoiceTitle';
import InvoiceNo from './InvoiceNo';
import BillTo from './BillTo';
import InvoiceThankYouMsg from './InvoiceThankYouMsg';
import InvoiceItemsTable from './InvoiceItemsTable';
import InvoiceItemsTableDespesa from './InvoiceItemsTableDespesa';
import InvoiceCalc from './InvoiceCalc';
import InvoiceCons from './InvoiceCons';

const styles = StyleSheet.create({
  page: {
    backgroundColor: '#fff',
    fontFamily: 'Helvetica',
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 50,
    paddingRight: 50,
    lineHeight: 1.5,
    flexDirection: 'column',
  },
  logo: {
    width: 60,
    height: 50,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    borderWidth: 2,
    borderColor: '#3778C2',
    padding: 0,
    margin: 0,
  },
  column: {
    flex: 1,
  },
  flexBillTo: {
    justifyContent: 'flex-start',
    backgroundColor: '#add8e6',
  },
  flexInvoiceCons: {
    justifyContent: 'flex-start',
    backgroundColor: '#FFDEAD',
  },
  flexInvoiceCalc: {
    justifyContent: 'flex-start',
    backgroundColor: '#90EE90',
  },
});

function PdfDocument({ dados }) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Image style={styles.logo} src={logo} />
        <InvoiceTitle title="Controle de Viagens" />
        <InvoiceNo dados={dados} />
        <View style={styles.container}>
          <View style={[styles.column, styles.flexBillTo]}>
            <BillTo dados={dados} />
          </View>
          <View style={[styles.column, styles.flexInvoiceCons]}>
            <InvoiceCons dados={dados} />
          </View>
          <View style={[styles.column, styles.flexInvoiceCalc]}>
            <InvoiceCalc dados={dados} />
          </View>
        </View>

        <InvoiceItemsTable dados={dados} />
        <InvoiceItemsTableDespesa dados={dados} />
        <Text>(*)Atribuição de Despesa.</Text>
        <InvoiceThankYouMsg />
      </Page>
    </Document>
  );
}

export default PdfDocument;
